require('element-matches-polyfill');

document.addEventListener("DOMContentLoaded", function () {
	if (document.location.href.indexOf('wp-admin') === -1){ 

		let nav = document.getElementById('nav');
		const focusTrap = require('focus-trap');
		let trap = false;
		let open_sub_menu = false;

		//prevents the closing of the nav
		let nav_testing_mode = false;

		nav.addEventListener('keydown', function(event) {

			//if this isn't an a tag
			if (!event.target.matches('a')) return;

			if(event.target.parentNode.classList.contains('menu-item') && event.target.parentNode.classList.contains('menu-item-has-children') && !event.target.parentNode.parentNode.parentNode.classList.contains('menu-item-has-children')) {

				if (event.key === 'ArrowDown' || event.key === ' ') {
					event.preventDefault();
					document.body.classList.add('nav-shade');
					event.target.classList.add('active');
					event.target.classList.add('sub-menu-transition');
					event.target.parentNode.classList.toggle('keyboard-sub-menu-open');

					//if this menu has just been open
					if(event.target.parentNode.classList.contains('keyboard-sub-menu-open')) {

						//get all siblings
						let siblings = (event.target.parentNode.parentNode).querySelectorAll(('.keyboard-sub-menu-open:not(#' + event.target.parentNode.id + ')'));

						//if we have siblings
						if(siblings && siblings.length > 0) {

							//loop over them
							for(let i = 0; i < siblings.length; i++) {

								//remove the class
								siblings[i].classList.remove('keyboard-sub-menu-open');
							}
						}
					}

					window.setTimeout(function () {
						event.target.parentElement.querySelector(".sub-menu li:nth-of-type(2) a").focus();
					}, 100);
				}
				//this has grandchildren
			} else if (event.target.parentNode.classList.contains('menu-item-has-children') && event.target.parentNode.parentNode.parentNode.classList.contains('menu-item-has-children') && !event.target.parentElement.parentElement.parentElement.querySelector("a").classList.contains('rg-mega-menu') && !event.target.parentElement.parentElement.parentElement.querySelector("a").classList.contains('rg-mega-menu--single') && !event.target.parentElement.parentElement.parentElement.querySelector("a").classList.contains('rg-mega-menu--multiple')  ) {
				if (event.key === 'ArrowDown' || event.key === 'ArrowRight' || event.key === ' ') {
					event.preventDefault();
					event.target.classList.add('active');
					event.target.parentNode.classList.toggle('keyboard-sub-menu-open');
					window.setTimeout(function () {
						event.target.parentElement.querySelector(".sub-menu li:nth-of-type(2)").querySelector("a").focus();
					}, 100);
				}
			} else if (event.target.parentNode.classList.contains('menu-item-has-children') && event.target.parentNode.parentNode.parentNode.classList.contains('menu-item-has-children') && !event.target.parentElement.parentElement.parentElement.querySelector("a").classList.contains('rg-mega-menu') && (event.target.parentElement.parentElement.parentElement.querySelector("a").classList.contains('rg-mega-menu--single') || event.target.parentElement.parentElement.parentElement.querySelector("a").classList.contains('rg-mega-menu--multiple'))) {
				if (event.key === 'ArrowDown' || event.key === 'ArrowRight' || event.key === ' ' || event.key === 'Enter') {
					event.preventDefault();
					event.target.classList.add('active');
					event.target.parentNode.classList.toggle('keyboard-sub-menu-open');
					window.setTimeout(function () {
						event.target.parentElement.querySelector(".sub-menu li:nth-of-type(2)").querySelector("a").focus();
					}, 100);
				}
			}

		}, false);

		nav.addEventListener('keydown', (event) => {


			if (event.target.parentNode.parentNode.classList.contains('sub-menu') && !event.target.parentNode.parentNode.parentNode.parentNode.classList.contains('sub-menu')){
			//if the escape key is pressed
				if (event.key === 'Escape' || event.key === 'ArrowUp' || ((event.key === 'Tab' && !event.shiftKey) && event.target.parentNode.nextElementSibling === null && !event.target.classList.contains('active'))) {

					//grab all open keyboard menus
					var elems = document.querySelectorAll(".keyboard-sub-menu-open");

					//if we have some sub-menu's to close
					if(elems) {

						//loop through them
						[].forEach.call(elems, function(el) {
							el.classList.remove("keyboard-sub-menu-open");
							el.firstChild.classList.remove('active');
							el.firstChild.classList.remove('sub-menu-transition');
						});

						document.body.classList.remove('nav-shade');


						//if we have an active focus trap
						if(trap) {

							//end it
							trap.deactivate();
						}

						window.setTimeout(function () {
							if ((event.key === 'Tab' && !event.shiftKey) && event.target.parentNode.nextElementSibling === null && !event.target.classList.contains('active')) {
								event.target.parentNode.parentNode.parentElement.nextElementSibling.querySelector("a").focus();
							} else {
								event.target.parentNode.parentNode.parentElement.querySelector("a").focus();
							}
						}, 0);
					}
				}
			} else if (event.target.parentNode.parentNode.parentNode.parentNode.classList.contains('sub-menu')){
				if (event.key === 'ArrowUp' || event.key === 'ArrowLeft' || event.key === 'Escape') {
					event.target.parentNode.parentNode.parentElement.querySelector("a").classList.remove("active");
					window.setTimeout(function () {
						event.target.parentNode.parentNode.parentElement.querySelector("a").focus();
					}, 0);
				} else if ((event.key === 'Tab' && !event.shiftKey) && event.target.parentNode.nextElementSibling === null ) {
						if (event.target.parentNode.parentNode.parentElement.nextElementSibling === null) {
							event.target.parentNode.parentNode.parentElement.parentElement.parentElement.querySelector("a").classList.remove("active");
							window.setTimeout(function () {
								var elems = document.querySelectorAll(".keyboard-sub-menu-open");

								//if we have some sub-menu's to close
								if(elems) {

									//loop through them
									[].forEach.call(elems, function(el) {
										el.classList.remove("keyboard-sub-menu-open");
										el.firstChild.classList.remove('active');
										el.firstChild.classList.remove('sub-menu-transition');
									});

									document.body.classList.remove('nav-shade');


									//if we have an active focus trap
									if(trap) {

										//end it
										trap.deactivate();
									}
								}

								event.target.parentNode.parentNode.parentElement.parentElement.parentElement.nextElementSibling.querySelector("a").focus();
							}, 0);
						} else {
							event.target.parentNode.parentNode.parentElement.querySelector("a").classList.remove("active");
							window.setTimeout(function () {
								event.target.parentNode.parentNode.parentElement.nextElementSibling.querySelector("a").focus();
							}, 0);
						}
					// }
				}
			}
		});

		function open_child_menu(event) {

			//if this is mobile, ignore any events
			if (!window.matchMedia("(min-width: 1280px)").matches) {
				return;
			}

			// If we're hovering over a parent link or a sub-menu
			if (event.target.matches('#menu-main-nav') || event.target.matches('.desktop-parent-link-toggle') || event.target.matches('.sub-menu') || event.target.matches('.menu-item')) {

				if (event.target.matches('.desktop-parent-link-toggle') && event.target.parentElement.classList.contains('menu-item-has-children') && !event.target.parentElement.parentElement.parentElement.children[0].classList.contains('rg-mega-menu') && !event.target.parentElement.parentElement.parentElement.parentElement.classList.contains('sub-menu')) {
					event.preventDefault();

					//this will help us determine if the same element has been clicked multiple times
					let same_origin = event.target.parentElement.id == open_sub_menu;

					//if this is not a mouseover event
					if (event.type != "mouseover" && nav_testing_mode == false) {
						//close all menus
						close_child_menu(null);
					}

					let mega_menu = false;

					if (event.target.classList.contains('rg-mega-menu') || event.target.classList.contains('rg-mega-menu--single') || event.target.classList.contains('rg-mega-menu--multiple')){
						mega_menu = true;
					}


					//if it was a different item
					if (!same_origin) {

						let anim_timeout = 0;


						//close all menus, the function will tell us how many open items there are
						if(close_child_menu(event.target.parentElement.parentElement.classList)) {
							if (!event.target.parentElement.parentElement.classList.contains('sub-menu')) {
								anim_timeout = 200;
							}
							//increase animation timeout
						}

						//this is wrapped in a timeout to account for the smooth closing and opening of menus
						setTimeout(function() {

							//if this menu item has a dropdown
							if(event.target.parentElement.classList.contains('menu-item-has-children')) {

								//add the nav shade
								document.body.classList.add('nav-shade');
							}

							//open sub-menu
							event.target.classList.add('active');
							event.target.classList.add('sub-menu-transition');

							if (mega_menu === true) { 
								const mega_menu_item = event.target.parentElement.querySelector('.sub-menu li.menu-item-has-children .desktop-parent-link-toggle');

								if (mega_menu_item) {
									mega_menu_item.classList.add('active');
									mega_menu_item.classList.add('sub-menu-transition');
								}
							}
							open_sub_menu = event.target.parentElement.id;
						}, anim_timeout);
					}
				} else if (event.target.parentElement.parentElement.parentElement.children[0].classList.contains('rg-mega-menu') && event.target.parentElement.childElementCount > 1) {
					event.preventDefault();

					//this will help us determine if the same element has been clicked multiple times
					let same_origin = event.target.parentElement.id == open_sub_menu;

					//if this is not a mouseover event
					if (event.type != "mouseover" && nav_testing_mode == false) {
						//close all menus
						close_child_menu(null);
					}

					//if it was a different item
					if (!same_origin) {

						let anim_timeout = 0;

						//close all menus, the function will tell us how many open items there are
						if(close_child_menu(event.target.parentElement.parentElement.classList)) {
							if (!event.target.parentElement.parentElement.classList.contains('sub-menu')) {
								anim_timeout = 200;
							}
							//increase animation timeout
						}

						//this is wrapped in a timeout to account for the smooth closing and opening of menus
						setTimeout(function() {

							//if this menu item has a dropdown
							if(event.target.parentElement.classList.contains('menu-item-has-children')) {

								//add the nav shade
								document.body.classList.add('nav-shade');
							}

							//open sub-menu
							// event.target.classList.add('active');
							// event.target.classList.add('sub-menu-transition');
							// open_sub_menu = event.target.parentElement.id;
						}, anim_timeout);
					}
				}
			} else if(nav_testing_mode == false) {

				//close all menus
				close_child_menu(null);
			}
		}

		function close_child_menu(element) {

			//fetch open menus
			let open_menus = document.querySelectorAll('.desktop-parent-link-toggle.active');
			var grandchild = false;


			//if grandchild fetch correct open menus
			if (element != null && element.contains('sub-menu')) {
				grandchild = true;
				open_menus = document.querySelectorAll('.menu-item-has-children .sub-menu .desktop-parent-link-toggle.active');
			}

			//if we have some open menus
			if (open_menus) {

				//loop through then
				for (let i = 0; i < open_menus.length; i++) {

					//if this isn't a button
					if(typeof open_menus[i] != 'undefined' && !open_menus[i].matches('.btn')) {

						//close them
						open_menus[i].classList.remove('sub-menu-transition');

						if (grandchild === true) {
							open_menus[i].classList.remove('active');
						} else {
							setTimeout(function(menu) {

								menu.classList.remove('active');

							}, 200, open_menus[i]);
						}
					}
				}
			}

			if (grandchild === false) {
				document.body.classList.remove('nav-shade');
			}
			open_sub_menu = false;

			return (open_menus.length);
		}

		function set_nav_focus_trap(target) {

			if (trap) {
				//deactivate the current trap
				trap.deactivate();
			}

			//re-intiialize the trap with the new target
			trap = focusTrap.createFocusTrap([nav, target]);

			setTimeout(function () {

				//activate it
				trap.activate();
			}, 100);
		}

		function debounce(func, wait = 100) {
			let timeout;
			return function (...args) {
				clearTimeout(timeout);
				timeout = setTimeout(() => {
					func.apply(this, args);
				}, wait);
			};
		}

		function close_mobile_nav_on_resize(event) {

			//if this is desktop and the mobile menu is currently open
			if(window.matchMedia("(min-width: 1280px)").matches && document.body.classList.contains('nav-open')) {

				//close mobile nav
				document.body.classList.remove('nav-open');
				document.documentElement.classList.remove('nav-open');

				//if the trap currently exists
				if(trap) {
					//deactivate focus trap
					trap.deactivate();
				}
			}
		}

		// Wrap the open_child_menu function with debounce to prevent more than 1 opening at once
		const debouncedOpenChildMenu = debounce(open_child_menu, 100);
		document.addEventListener('mouseover', debouncedOpenChildMenu, false);
		nav.addEventListener('click', open_child_menu, false);

		window.addEventListener('resize', debounce(close_mobile_nav_on_resize, 500));
		document.body.addEventListener('click', debounce(close_mobile_nav_on_resize, 500))

		nav.addEventListener('click', function (event) {

			// If the clicked element isn't the hamburger, return
			if (!event.target.matches('#hamburger')) return;

			//if the nav isn't currently open
			if (!document.body.classList.contains('nav-open')) {

				//clear and re-initialize focus trap
				set_nav_focus_trap(nav);

				//add the active class on the body & html
				document.body.classList.add('nav-open');
				document.documentElement.classList.add('nav-open');

				//add this class to indicate the nav has been opened
				document.body.classList.add('nav-opened');
				

				setTimeout(function () {
					//activate focus trap
					trap.activate();
				}, 100);
			} else if (trap) {
				//deactivate focus trap
				trap.deactivate();

				//remove the active class on the body
				document.body.classList.remove('nav-open');
				document.documentElement.classList.remove('nav-open');

				//select all mobile menu items
				let menu_items = document.getElementsByClassName('mobile-menu-item');

				//if we have some items to loop through
				if(menu_items && menu_items.length > 0) {

					//loop through them
					for(let i = 0; i < menu_items.length; i++) {

						//remove the animation classes
						menu_items[i].classList.remove('active');
						menu_items[i].classList.remove('sub-menu-transition');
					}
				}
			}
		}, false);

		document.addEventListener('click', function (event) {

			// If the clicked element isn't the footer menu name, return
			if (!event.target.matches('.footer-menu-name')) return;

			//toggle the open class on the body
			event.target.classList.toggle('open');

		}, false);

		document.addEventListener('click', function (event) {

			// If the clicked element isn't the mobile sub menu item, return
			if (!event.target.matches('.mobile-menu-item')) return;

			if(event.target.parentElement.classList.contains('menu-item-has-children')) {
				event.preventDefault();
			}

			//clear and re-initialize focus trap
			set_nav_focus_trap(event.target.nextElementSibling);

			//toggle the open class on the body
			event.target.classList.toggle('active');
			event.target.classList.toggle('sub-menu-transition');

		}, false);

		document.addEventListener('click', function (event) {

			// If the clicked element isn't the close mobile sub-menu, return
			if (!event.target.matches('.sub-menu-close')) return;

			//clear and re-initialize focus trap
			set_nav_focus_trap(nav);

			//toggle the open class on the body
			event.target.parentElement.parentElement.previousElementSibling.classList.toggle('active');
			event.target.parentElement.parentElement.previousElementSibling.classList.toggle('sub-menu-transition');

		}, false);
	}
});